export enum MicroVariableActionsTypes {
  GET_MICRO_VARIABLES_SUCCESS = 'GET_MICRO_VARIABLES_SUCCESS',
  GET_MICRO_VARIABLES_FAILED = 'GET_MICRO_VARIABLES_FAILED',
  GET_MICRO_VARIABLES_REQUEST = 'GET_MICRO_VARIABLES_REQUEST',
  RESET_MICRO_VARIABLES = 'RESET_MICRO_VARIABLES',
  SHOW_FILTER_MICRO_VARIABLES = 'SHOW_FILTER_MICRO_VARIABLES',
  UPDATE_MICRO_VARIABLE_FILTER_DEFIS = 'UPDATE_MICRO_VARIABLE_FILTER_DEFIS',
  UPDATE_MICRO_VARIABLE_FILTER_RESSOURCES = 'UPDATE_MICRO_VARIABLE_FILTER_RESSOURCES',
}
